import { FeatureFlags } from '@domain/types';

/**
 * Copy of the feature flags for the Redux side only (sagas, middlewares), which cannot read
 * React context. FeatureFlagsProvider is the only writer.
 *
 * Do not use it from React: read `useFeatureFlags()`. It is not reactive, so a component reading
 * it would not re-render when a flag changes.
 *
 * Temporary: delete it with the last saga / middleware that reads it.
 *
 * @deprecated Redux-only bridge, see above.
 */
class LegacyFeatureFlagsStore {
  private flags: FeatureFlags = {};

  public get(): FeatureFlags {
    return this.flags;
  }

  public set(flags: FeatureFlags): void {
    this.flags = flags;
  }

  public merge(changedFlags: Partial<FeatureFlags>): void {
    this.flags = { ...this.flags, ...changedFlags };
  }
}

export const legacyFeatureFlagsStore = new LegacyFeatureFlagsStore();
